import { X, Trash2, Plus, Minus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export const CartDrawer = () => {
  const { items, open, setOpen, removeItem, updateQty, subtotal, clear } = useCart();

  return (
    <>
      {open && (
        <div
          data-testid="cart-overlay"
          className="fixed inset-0 bg-black/60 z-50 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        />
      )}
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 h-full w-full sm:w-[420px] bg-surface z-50 shadow-2xl transition-transform duration-300 flex flex-col ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between p-6 border-b border-rule">
          <div>
            <div className="overline-label text-signal">Field Kit</div>
            <h2 className="font-display text-2xl font-bold text-ink">Your Cart</h2>
          </div>
          <button data-testid="cart-close" onClick={() => setOpen(false)} className="p-2 text-muted-ink hover:text-signal">
            <X size={22} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-5">
          {items.length === 0 && (
            <div className="text-center py-20">
              <p className="font-mono2 text-xs tracking-[0.2em] text-muted-ink uppercase">// Cart Empty</p>
              <p className="font-body text-muted-ink mt-3">No field gear selected yet.</p>
            </div>
          )}
          {items.map((i) => (
            <div key={i.key} data-testid={`cart-item-${i.key}`} className="flex gap-4 border-b border-rule pb-5">
              <img src={i.image_url} alt={i.name} className="w-20 h-24 object-cover" />
              <div className="flex-1">
                <h3 className="font-grotesk font-semibold text-sm text-ink leading-snug">{i.name}</h3>
                <p className="font-mono2 text-[0.65rem] text-muted-ink mt-1 uppercase tracking-wider">Size: {i.size}</p>
                <div className="flex items-center justify-between mt-3">
                  <div className="flex items-center gap-2 border border-rule">
                    <button data-testid={`cart-dec-${i.key}`} onClick={() => updateQty(i.key, i.qty - 1)} className="p-1.5 text-muted-ink hover:text-signal">
                      <Minus size={12} />
                    </button>
                    <span className="font-mono2 text-xs w-5 text-center text-ink">{i.qty}</span>
                    <button data-testid={`cart-inc-${i.key}`} onClick={() => updateQty(i.key, i.qty + 1)} className="p-1.5 text-muted-ink hover:text-signal">
                      <Plus size={12} />
                    </button>
                  </div>
                  <span className="font-mono2 text-sm text-ink">${(i.price * i.qty).toFixed(2)}</span>
                </div>
              </div>
              <button data-testid={`cart-remove-${i.key}`} onClick={() => removeItem(i.key)} className="text-muted-ink hover:text-signal self-start">
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="p-6 border-t border-rule space-y-4">
            <div className="flex justify-between items-baseline">
              <span className="font-mono2 text-xs uppercase tracking-[0.2em] text-muted-ink">Subtotal</span>
              <span data-testid="cart-subtotal" className="font-display text-2xl font-bold text-ink">${subtotal.toFixed(2)}</span>
            </div>
            <button
              data-testid="cart-checkout"
              onClick={() => toast("Checkout is a demo", { description: "Payment processing isn't wired up yet — this is a preview store." })}
              className="w-full bg-signal text-white font-mono2 text-xs uppercase tracking-[0.2em] py-4 hover:opacity-90 transition-opacity"
            >
              Proceed to Checkout
            </button>
            <button data-testid="cart-clear" onClick={clear} className="w-full font-mono2 text-[0.65rem] uppercase tracking-[0.2em] text-muted-ink hover:text-signal py-1">
              Clear Cart
            </button>
            <p className="font-body text-xs text-muted-ink text-center italic">Demo store — no real payment is taken.</p>
          </div>
        )}
      </aside>
    </>
  );
};
